/*Date import section*/
import { DatePipe, registerLocaleData } from '@angular/common';
import { LocalizedDatePipe } from './pipe/localized-date.pipe';

/*import localeFr from '@angular/common/locales/fr-CA';*/
const localeFr = [
    'fr',
    [
        ['a', 'p'],
        ['a.m.', 'p.m.'],
    ],
    [
        ['AM', 'PM'],
        ['a.m.', 'p.m.'],
    ],
    [
        ['D', 'L', 'M', 'M', 'J', 'V', 'S'], ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        ['di', 'lu', 'ma', 'me', 'je', 've', 'sa']
    ],
    ,
    [
        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        [
            'janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juill.', 'août', 'sept.', 'oct.', 'nov.',
            'déc.'
        ],
        [
            'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre',
            'octobre', 'novembre', 'décembre'
        ]
    ],
    ,
    [['av. J.-C.', 'ap. J.-C.'], , ['avant Jésus-Christ', 'après Jésus-Christ']], 0, [6, 0],
    ['yy-MM-dd', 'd MMM y', 'd MMMM y', 'EEEE d MMMM y'],
    ['HH \'h\' mm', 'HH:mm:ss', 'HH:mm:ss', 'HH:mm:ss zzzz'],
    [
        '{1} {0}',
        ,
        '{1} \'à\' {0}',
    ],
    [',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
    ['#,##0.###', '#,##0 %', '#,##0.00 ¤', '#E0'], '$', 'dollar canadien',
    function (n) {
        const i = Math.floor(Math.abs(n));
        if (i === 0 || i === 1) {
            return 1;
        }
        return 5;
    }
];
registerLocaleData(localeFr, 'fr');

/*import localeEn from '@angular/common/locales/en-CA';*/
const localeEn = [
    'en',
    [
        ['a', 'p'],
        ['AM', 'PM'],
    ],
    [
        ['AM', 'PM'],
        ,
    ],
    [
        ['S', 'M', 'T', 'W', 'T', 'F', 'S'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    ],
    ,
    [
        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        [
            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
            'October', 'November', 'December'
        ]
    ],
    ,
    [['B', 'A'], ['BC', 'AD'], ['Before Christ', 'Anno Domini']], 0, [6, 0],
    ['y-MM-dd', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
    ['h:mm a', 'h:mm:ss a', 'h:mm:ss a', 'h:mm:ss a zzzz'],
    [
        '{1}, {0}',
        ,
        '{1} \'at\' {0}',
    ],
    ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
    ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '$', 'Canadian Dollar',
    function (n) {
        const i = Math.floor(Math.abs(n)), v = n.toString().replace(/^[^.]*\.?/, '').length;
        if (i === 1 && v === 0) {
            return 1;
        }
        return 5;
    }
];
registerLocaleData(localeEn);

/*Date import section*/

import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/*Translation import section*/
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
/*Translation import section*/

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { BottomNavComponent } from './components/bottom-nav/bottom-nav.component';
import { PaymentComponent } from './components/payment/payment.component';
import { InvoiceComponent } from './components/payment/invoice/invoice.component';
import { MoneticoPaymentComponent } from './components/payment/monetico-payment/monetico-payment.component';
import { GlobalPaymentComponent } from './components/payment/global-payment/global-payment.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaymentErrorComponent } from './components/payment/payment-error/payment-error.component';

import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { DateAdapter, MatNativeDateModule } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { PaymentService } from './services/payment.service';
import { ParameterService } from './services/parameter.service';
import { PaymentNotFoundComponent } from './components/payment/payment-not-found/payment-not-found.component';
import { StripeCheckoutComponent } from './components/payment/stripe-checkout/stripe-checkout.component';
import { ThemePipe } from './pipe/theme.pipe';
import { Base64ImagePipe } from './pipe/base64-image.pipe';
import { InvoiceService } from './services/invoice.service';
import { PaysafeCheckoutComponent } from './components/payment/paysafe-checkout/paysafe-checkout.component';
import { PictureService } from './services/picture.service';
import { TaxGroupService } from './services/tax-group.service';
import { PaymenttechFormComponent } from './components/payment/paymenttech-form/paymenttech-form.component';
// tslint:disable-next-line: max-line-length
import { PaymenttechFormPopupComponent } from './components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component';
import { DowloadInvoiceComponent } from './components/payment/dowload-invoice/dowload-invoice.component';
import { LocalizationService } from './services/localization.service';
import { BalanceOverLimitComponent } from './components/payment/balance-over-limit/balance-over-limit.component';
import { MonerisCheckoutComponent } from './components/payment/moneris-checkout/moneris-checkout.component';
import { SearchInvoiceComponent } from './components/search-invoice/search-invoice.component';
import { NuveiCheckoutModalComponent } from './components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component';
import { NuveiCheckoutComponent } from './components/payment/nuvei-checkout/nuvei-checkout.component';

@NgModule({
  declarations: [
    AppComponent,
    TopNavComponent,
    BottomNavComponent,
    PaymentComponent,
    InvoiceComponent,
    MoneticoPaymentComponent,
    GlobalPaymentComponent,
    NotFoundComponent,
    PaymentErrorComponent,
    PaymentNotFoundComponent,
    ThemePipe,
    StripeCheckoutComponent,
    Base64ImagePipe,
    PaysafeCheckoutComponent,
    PaymenttechFormComponent,
    PaymenttechFormPopupComponent,
    DowloadInvoiceComponent,
    BalanceOverLimitComponent,
    MonerisCheckoutComponent,
    SearchInvoiceComponent,
    LocalizedDatePipe,
    NuveiCheckoutComponent,
    NuveiCheckoutModalComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'payment-platform'}),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    DateValueAccessorModule,
    MatNativeDateModule,
    RouterModule.forRoot(routes),
    BrowserTransferStateModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  entryComponents: [
    PaymenttechFormPopupComponent,
    NuveiCheckoutModalComponent
  ],
  providers: [
    PaymentService, ParameterService, InvoiceService, PictureService, TaxGroupService, LocalizationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/app.module.ts